// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"4fc8e36eaebc840c","5763":"473397a43af3dd02","6893":"80b093b7bf833aee","6974":"df5c5973c1d78812","7222":"c76dfc54f873867a","7937":"60cf48b5851ee282"}[chunkId] + ".js";
};